import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    if (protocol === 'https:' || port === '80' || port === '443') return '';
    return `${protocol}//${hostname}:5000`;
  }
  return 'http://localhost:5000';
};

const RedefinirSenha = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithSession } = useAuth();
  const token = searchParams.get('token') || '';
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [validando, setValidando] = useState(!!token);
  const [tokenValido, setTokenValido] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setValidando(false);
      setTokenValido(false);
      setError('Link inválido. Solicite uma nova redefinição de senha.');
      return;
    }
    const validar = async () => {
      try {
        const res = await axios.get(`${getApiBaseUrl()}/api/auth/redefinir-senha/validar`, { params: { token } });
        setTokenValido(res.data?.valid === true);
      } catch {
        setTokenValido(false);
        setError('Link inválido ou expirado. Solicite um novo link em "Esqueci minha senha".');
      } finally {
        setValidando(false);
      }
    };
    validar();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage(null);
    if (novaSenha.length < 6) {
      setError('A senha deve ter no mínimo 6 caracteres.');
      return;
    }
    if (novaSenha !== confirmarSenha) {
      setError('As senhas não coincidem.');
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${getApiBaseUrl()}/api/auth/redefinir-senha`, { token, nova_senha: novaSenha });
      if (res.data?.token && res.data?.user) {
        await loginWithSession(res.data.token, res.data.user);
        navigate('/home', { replace: true });
        return;
      }
      setMessage(res.data?.message || 'Senha alterada. Faça login com a nova senha.');
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao redefinir senha. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (validando) {
    return (
      <div className="login-container">
        <div className="login-card glass">
          <p className="text-muted">Validando link…</p>
        </div>
      </div>
    );
  }

  if (!tokenValido) {
    return (
      <div className="login-container">
        <div className="login-card glass">
          <div className="login-header">
            <img src="/logo.png" alt="Green Check" className="login-logo" />
            <h1>Link inválido</h1>
            <p className="text-muted">{error}</p>
          </div>
          <p className="login-footer">
            <Link to="/esqueci-senha">Solicitar novo link</Link>
            <span> · </span>
            <Link to="/login">Voltar ao login</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card glass">
        <div className="login-header">
          <img src="/logo.png" alt="Green Check" className="login-logo" />
          <h1>Nova senha</h1>
          <p className="text-muted">Digite e confirme sua nova senha</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}
          <div className="form-group">
            <label>Nova senha</label>
            <input
              type="password"
              className="form-control"
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              required
              minLength={6}
              placeholder="Mínimo 6 caracteres"
              disabled={!!message}
            />
          </div>
          <div className="form-group">
            <label>Confirmar senha</label>
            <input
              type="password"
              className="form-control"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              required
              minLength={6}
              placeholder="Repita a senha"
              disabled={!!message}
            />
          </div>
          <button type="submit" className="btn-primary" disabled={loading || !!message}>
            {loading ? 'Salvando…' : 'Alterar senha'}
          </button>
          {message && (
            <p className="login-footer">
              <Link to="/login">Ir para o login</Link>
            </p>
          )}
          {!message && (
            <p className="login-footer">
              <Link to="/login">Voltar ao login</Link>
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default RedefinirSenha;
